import { render } from "./SelectResource.vue?vue&type=template&id=c586865e&ts=true"
import script from "./SelectResource.vue?vue&type=script&lang=ts"
export * from "./SelectResource.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__